import {
  createTranslationMessages,
  createTranslationResource,
} from '@backstage/core-plugin-api/alpha';
import { ciandtspikeOnboardingTranslationRef } from '../translation';

export const availableLanguages = ['en', 'pt-BR'] as const;

export async function loadPtBrTranslations() {
  const ptBrModule = await import('./pt-BR.json');
  return {
    default: createTranslationMessages({
      ref: ciandtspikeOnboardingTranslationRef,
      full: false,
      messages: ptBrModule.default,
    }),
  };
}

export const ciandtspikeOnboardingTranslations = createTranslationResource({
  ref: ciandtspikeOnboardingTranslationRef,
  translations: {
    'pt-BR': loadPtBrTranslations,
  },
});
